import { ClientResponseAuditable } from '../../../../web-api-client';
import { Client } from '../../models';

export const mapClientFromResponse = (
  response: ClientResponseAuditable
): Client => ({
  clientId: response.clientId!,
  name: response.name!,
  isActive: response.isActive ?? false,
  description: response.description,
  created: response.created!,
});
